
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Erika ist jetzt ein Rind und wird von einem Besamungstechniker oder Tierarzt künstlich besamt.
Das klappt meist beim ersten Versuch. Ein einziger Bulle kann jährlich mehrere Zehntausend Nachkommen zeugen.
285 Tage später bringt Erika ihr erstes Kalb in einer separaten Abkalbebucht zur Welt, das ihr sogleich nach der
Geburt weggenommen wird. Erika ist jetzt eine Erstmelkkuh. In der Schweiz leben 560’000 Milchkühe – dies ist
der tiefste Stand seit Ende der 1980er-Jahre. Jede von ihnen bekommt jedes Jahr ein Kalb. Denn: Damit Kühe
Milch geben, müssen sie jedes Jahr kalbern. Erika gibt rund 25 Liter Milch pro Tag. Die Milchleistung der
Schweizer Kühe hat infolge intensiver Zucht in den letzten drei Jahrzehnten um 30 Prozent zugenommen.`}</p>
    <Image file={[require('images/milchproduktion-01.svg'), require('images/milchproduktion-02.svg')]} title='Milchleistung' subtitle='pro Kuh und Jahr in kg, 2016' source='Quelle: Europäische Kommission, Bundesamt für Landwirtschaft, Department of Agriculture' mdxType="Image" />
  
Die Milchwirtschaft ist der wichtigste Sektor der Schweizer Landwirtschaft mit einem Anteil von rund 
20 Prozent an der Erzeugung des gesamten landwirtschaftlichen Wirtschaftsbereichs. Es gibt in der 
Schweiz noch rund 19’500 Bauernbetriebe mit Milchproduktion, nur 10 Prozent sind Biobetriebe. Jeden 
Tag geben zwei auf. Häufiger Grund: Angesichts der tiefen Milchpreise wird die Milchproduktion 
aufgegeben und auf Fleischproduktion umgestiegen.
    <Image file={[require('images/milchpreis-01.svg'), require('images/milchpreis-02.svg')]} title='Entwicklung des Milchpreises' subtitle='in Rappen pro Kilo' source='Quelle: Bundesamt für Landwirtschaft' mdxType="Image" />
    <p>{`Erikas Milch wird zu 43 Prozent zu Käse verarbeitet. Für ein Kilo Hartkäse braucht es rund 13 Liter Milch.
Aus den restlichen 57 Prozent entsteht Butter (15 Prozent), Milchpulver und Ähnliches (10,8 Prozent),
Konsummilch (11,2 Prozent), Rahm (8,3 Prozent), Joghurt (3,4 Prozent) oder Quark (0,8 Prozent).`}</p>
    <Image file={[require('images/milchprodukte-01.svg'), require('images/milchprodukte-02.svg')]} title='Kuhmilchverabeitung in der Schweiz' subtitle='nach Produkten, 2017' source='Quelle: www.agrarbericht.ch' mdxType="Image" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;